import React, { Component } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { WithStyles } from 'decorators/withStyles';

interface IProps {
  classes?: any;
  open?: boolean;
  title: string | React.ReactNode;
  children: React.ReactElement<any>;
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
}

interface IState {
  arrowRef: any;
}

function arrowGenerator(color: string) {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.95em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '0 1em 1em 1em',
        borderColor: `transparent transparent ${color} transparent`
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.95em',
      width: '3em',
      height: '1em',
      '&::before': {
        borderWidth: '1em 1em 0 1em',
        borderColor: `${color} transparent transparent transparent`
      }
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.95em',
      height: '3em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 1em 1em 0',
        borderColor: `transparent ${color} transparent transparent`
      }
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-0.95em',
      height: '3em',
      width: '1em',
      '&::before': {
        borderWidth: '1em 0 1em 1em',
        borderColor: `transparent transparent transparent ${color}`
      }
    }
  };
}

@WithStyles(theme => ({
  arrowPopper: arrowGenerator('#37474F'),
  blueTooltip: {
    backgroundColor: '#37474F',
    color: 'rgba(255, 255, 255, 0.87)',
    padding: 16,
    boxShadow: theme.shadows[1],
    fontSize: 11,
    right: 10,
    maxWidth: 280
  },
  arrow: {
    position: 'absolute',
    fontSize: 6,
    width: '3em',
    height: '3em',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid'
    }
  }
}))
export default class TooltipHelp extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { arrowRef: null };
  }

  handleArrowRef = (node: any) => {
    this.setState({
      arrowRef: node
    });
  };

  render() {
    const { children, classes, placement, title } = this.props;

    return (
      <Tooltip
        title={
          typeof title == 'string' ? (
            <React.Fragment>
              {title}
              <span className={classes.arrow} ref={this.handleArrowRef} />
            </React.Fragment>
          ) : (
            { title }
          )
        }
        placement={placement || 'top'}
        classes={{ popper: classes.arrowPopper, tooltip: classes.blueTooltip }}
        PopperProps={{
          popperOptions: {
            modifiers: {
              arrow: {
                enabled: Boolean(this.state.arrowRef),
                element: this.state.arrowRef
              }
            }
          }
        }}
      >
        {children}
      </Tooltip>
    );
  }
}
